const state = {
    isCookieToastVisible: false
};

const getters = {
    isCookieToastVisible: state => state.isCookieToastVisible
};

const mutations = {
    setCookieToastVisible: (state, data) => state.isCookieToastVisible = data
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    strict: false
};